module.exports = __webpack_public_path__ + "static/media/MHRP29N0022.260563b4.svg";